import ReactGA from 'react-ga';
ReactGA.initialize('UA-113392157-1');
ReactGA.pageview(window.location.pathname + window.location.search);


// WEBPACK FOOTER //
// ./src/utils/analytics.js